/*!
 * This file is part of {@see https://github.com/Deasign-russia/Euromed_invitro Euromed Invitro}.
 *
 * Copyright © 2015-present {@see http://deasign.ru/ Euromed Invitro}.
 *
 * Euromed Invitro is free software: you can redistribute it and/or modify it under the terms of the GNU Affero General Public
 * License as published by the Free Software Foundation, either version 3 of the License, or (at your option) any later
 * version.
 *
 * Euromed Invitro is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY; without even the implied warranty
 * of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License along with Euromed Invitro.
 * If not, see {@see http://www.gnu.org/licenses/ gnu.org/licenses}.
 */

/* jshint browser:true */

/**
 * Flexslider
 *
 * @author Denis Kovalskiy <denis@deasign.ru>
 * @copyright 2015-present Euromed Invitro
 * @license http://www.gnu.org/licenses/agpl.html AGPL-3.0
 * @see {@link http://deasign.ru/}
 * @since 1.1.0-dev
 */

(function ($) {
    $(function () {
        if ($().flexslider) {

            // Flex Slider for Home page
            $('.landing-slider .flexslider').flexslider({
                animation: "fade",
                controlNav: false,
                directionNav: true,
                pauseOnHover: true,
                pauseOnAction: false,
                smoothHeight: false,
                start: function (slider) {
                    slider.removeClass('loading');
                }
            });
        }
    });
})(jQuery);